module.exports = __webpack_public_path__ + "static/media/banner.3065256d.jpg";